module.exports = __webpack_public_path__ + "708de88ec67945dc606b0e67ccd4d3c9.gif";